<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0 justify-content-between">
        <h5 class="card-title font-bold">سریال های محصول</h5>
        <b-button v-b-modal.modal-add-serials variant="success"
          >افزودن سریال</b-button
        >
      </div>
      <div class="card-body">
        <div>
          <b-table
            v-if="items && items.data && items.data.length"
            bordered
            :items="items.data"
            :fields="fields"
          >
            <template v-slot:cell(serial)="data">
              {{ data.item.serial }}
            </template>
            <template v-slot:cell(status)="data">
              <span
                v-if="data.item.status === 'damaged'"
                class="badge badge-danger status"
                >معیوب</span
              >
              <span
                v-else-if="data.item.status === 'available'"
                class="badge badge-success status"
                >موجود</span
              >
              <span
                v-else-if="data.item.status === 'draft'"
                class="badge badge-info status"
                >پیش نویس</span
              >
            </template>
            <template v-slot:cell(delete)="data">
              <span
                @click="deleteItem(data.item.id)"
                class="btn btn-outline-light"
              >
                <i class="feather feather-trash-2 text-danger"></i>
              </span>
            </template>
            <template v-slot:cell(edit)="data">
              <span @click="editItem(data.item)" class="btn btn-outline-light">
                <i class="feather feather-edit  text-primary"></i
              ></span>
            </template>
          </b-table>
          <div v-else class="alert alert-danger">
            موردی یافت نشد
          </div>
        </div>
      </div>
      <b-modal
        size="md"
        scrollable
        :hideFooter="true"
        id="modal-add-serials"
        title="سریال جدید"
      >
        <BForm @submit.prevent="submitHandler">
          <template v-for="(item, index) in serialInputs">
            <div class="row align-items-baseline" :key="index">
              <BFormGroup class="col-4" label="شماره سریال">
                <b-form-input type="number" v-model="item.serial" />
              </BFormGroup>
              <BFormGroup class="col-4" label="وضعیت">
                <BFormSelect v-model="item.status" :options="statusOptions" />
              </BFormGroup>
              <div
                class="row align-items-center justify-content-around flex-nowrap col-4"
              >
                <b-button
                  type="button"
                  @click="clickHandler('+')"
                  variant="success"
                  >افزودن</b-button
                >
                <b-button
                  type="button"
                  @click="clickHandler('-')"
                  variant="danger"
                  >حذف</b-button
                >
              </div>
            </div>
          </template>
          <b-button :disabled="disabled" variant="primary" type="submit"
            >ثبت</b-button
          >
        </BForm>
      </b-modal>
    </div>
    <b-modal
      size="md"
      centered
      :hideFooter="true"
      id="modal-edit-serials"
      title="ویرایش سریال"
    >
      <BForm @submit.prevent="editSubmitHandler">
        <div class="row align-items-baseline">
          <BFormGroup class="col-5" label="شماره سریال">
            <b-form-input type="number" v-model="editModalItem.serial" />
          </BFormGroup>
          <BFormGroup class="col-5" label="وضعیت">
            <BFormSelect
              v-model="editModalItem.status"
              :options="statusOptions"
            />
          </BFormGroup>
        </div>
        <b-button :disabled="disabled" variant="primary" type="submit"
          >ثبت</b-button
        >
      </BForm>
    </b-modal>
  </main>
</template>

<script>
import SerialsImpl from "@@/core/pages/serial/Serial/SerialsImpl.js";
export default {
  extends: SerialsImpl,
};
</script>
